<template>
  <div
    class="text-white bg-black py-16 px-12 px-md-16 d-flex flex-column"
    style="gap: 96px"
  >
    <div class="d-flex flex-column ga-12">
      <v-row>
        <v-col
          cols="12"
          md="9"
          class="inner-rounded pa-4 pa-sm-8"
          style="background-color: #131619"
        >
          <div class="text-h4 mb-2">Do you need help?</div>
          <p
            class="text-grey-darken-1 nhp"
            style="font-size: 14px"
          >
            We will provide detailed information about our services, types of work, and top
            projects. We will calculate the cost and prepare a commercial proposal.
          </p>
        </v-col>
        <v-col
          cols="12"
          md="3"
          class="d-flex justify-md-center align-md-center pa-4"
        >
          <router-link
            @click="scrollToTop()"
            to="/contact"
            class="text-decoration-none"
          >
            <div class="d-flex ga-2 align-center cursor-pointer text-white">
              <span>Get consultation</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 30 30"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M3 12h18m0 0l-8.5-8.5M21 12l-8.5 8.5"
                />
              </svg>
            </div>
          </router-link>
        </v-col>
      </v-row>
      <v-row class="text-grey-darken-1">
        <v-col
          cols="12"
          md="8"
          class="d-flex flex-column flex-md-row ga-12 justify-md-space-between"
        >
          <div class="d-flex flex-column ga-6">
            <div>COMPANY</div>
            <div>
              <ul style="list-style: none">
                <li>
                  <router-link
                    @click="scrollToTop()"
                    to="/"
                    class="text-decoration-none footer-nav-hover text-grey-darken-1"
                  >
                    Home
                  </router-link>
                </li>
                <li>
                  <router-link
                    @click="scrollToTop()"
                    to="/about"
                    class="text-decoration-none footer-nav-hover text-grey-darken-1"
                  >
                    About Us
                  </router-link>
                </li>
                <li>
                  <router-link
                    @click="scrollToTop()"
                    to="/services"
                    class="text-decoration-none footer-nav-hover text-grey-darken-1"
                  >
                    Services
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="d-flex flex-column ga-6">
            <div>HELP</div>
            <div>
              <ul style="list-style: none">
                <li>
                  <router-link
                    @click="scrollToTop()"
                    to="/contact"
                    class="text-decoration-none footer-nav-hover text-grey-darken-1"
                  >
                    Contact Us
                  </router-link>
                </li>
                <li
                  v-if="hasFAQLink"
                  class="footer-nav-hover"
                >
                  <router-link
                    @click.stop="scrollTo('faq')"
                    to="#faq"
                    class="text-decoration-none footer-nav-hover text-grey-darken-1"
                  >
                    FAQs
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="d-flex flex-column ga-6">
            <div>INFO</div>
            <div>
              <ul style="list-style: none">
                <li>
                  <router-link
                    @click="scrollToTop()"
                    to="/about"
                    class="text-decoration-none footer-nav-hover text-grey-darken-1"
                  >
                    Company Info
                  </router-link>
                </li>
                <li>
                  <router-link
                    @click="scrollToTop()"
                    to="/articles"
                    class="text-decoration-none footer-nav-hover text-grey-darken-1"
                  >
                    Articles
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="text-md-end"
        >
          <div>
            <div>
              <a
                href="tel:+13477809129"
                class="text-decoration-none text-grey-darken-1 footer-nav-hover"
              >
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.1 2.3C12.6 0.8 10.6 0 8.5 0C4.1 0 0.5 3.6 0.5 8C0.5 9.4 0.900006 10.8 1.60001 12L0.5 16L4.70001 14.9C5.90001 15.5 7.2 15.9 8.5 15.9C12.9 15.9 16.5 12.3 16.5 7.9C16.5 5.8 15.6 3.8 14.1 2.3ZM8.5 14.6C7.3 14.6 6.10001 14.3 5.10001 13.7L4.89999 13.6L2.39999 14.3L3.10001 11.9L2.89999 11.6C2.19999 10.5 1.89999 9.3 1.89999 8.1C1.89999 4.5 4.9 1.5 8.5 1.5C10.3 1.5 11.9 2.2 13.2 3.4C14.5 4.7 15.1 6.3 15.1 8.1C15.1 11.6 12.2 14.6 8.5 14.6ZM12.1 9.6C11.9 9.5 10.9 9 10.7 9C10.5 8.9 10.4 8.9 10.3 9.1C10.2 9.3 9.80001 9.7 9.70001 9.9C9.60001 10 9.49999 10 9.29999 10C9.09999 9.9 8.50001 9.7 7.70001 9C7.10001 8.5 6.70001 7.8 6.60001 7.6C6.50001 7.4 6.60001 7.3 6.70001 7.2C6.80001 7.1 6.9 7 7 6.9C7.1 6.8 7.10001 6.7 7.20001 6.6C7.30001 6.5 7.20001 6.4 7.20001 6.3C7.20001 6.2 6.80001 5.2 6.60001 4.8C6.50001 4.5 6.30001 4.5 6.20001 4.5C6.10001 4.5 5.99999 4.5 5.79999 4.5C5.69999 4.5 5.49999 4.5 5.29999 4.7C5.09999 4.9 4.60001 5.4 4.60001 6.4C4.60001 7.4 5.29999 8.3 5.39999 8.5C5.49999 8.6 6.79999 10.7 8.79999 11.5C10.5 12.2 10.8 12 11.2 12C11.6 12 12.4 11.5 12.5 11.1C12.7 10.6 12.7 10.2 12.6 10.2C12.5 9.7 12.3 9.7 12.1 9.6Z"
                    fill="#DEDEDE"
                  />
                </svg>
                347.780.9129
              </a>
            </div>
            <div>
              <a
                href="mailto:info@omegusprime.com"
                class="text-decoration-none text-grey-darken-1 footer-nav-hover"
              >
                info@omegusprime.com
              </a>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="text-grey-darken-1 d-flex flex-column ga-12">
      <v-row style="font-size: 12px">
        <v-col
          cols="6"
          style="height: 48px"
        >
          <div class="d-flex ga-2 align-center">
            <a
              href="https://www.instagram.com/omegusprime_llc/"
              target="_blank"
              rel="noopener noreferrer"
              class="d-flex ga-2 footer-nav-hover align-center text-decoration-none text-grey-darken-1"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.4">
                  <path
                    d="M8 1.44578C10.1205 1.44578 10.4096 1.44578 11.2771 1.44578C12.0482 1.44578 12.4337 1.63855 12.7229 1.73494C13.1084 1.92771 13.3976 2.0241 13.6867 2.31325C13.9759 2.60241 14.1687 2.89157 14.2651 3.27711C14.3614 3.56627 14.4578 3.95181 14.5542 4.72289C14.5542 5.59036 14.5542 5.78313 14.5542 8C14.5542 10.2169 14.5542 10.4096 14.5542 11.2771C14.5542 12.0482 14.3614 12.4337 14.2651 12.7229C14.0723 13.1084 13.9759 13.3976 13.6867 13.6867C13.3976 13.9759 13.1084 14.1687 12.7229 14.2651C12.4337 14.3614 12.0482 14.4578 11.2771 14.5542C10.4096 14.5542 10.2169 14.5542 8 14.5542C5.78313 14.5542 5.59036 14.5542 4.72289 14.5542C3.95181 14.5542 3.56627 14.3614 3.27711 14.2651C2.89157 14.0723 2.60241 13.9759 2.31325 13.6867C2.0241 13.3976 1.83133 13.1084 1.73494 12.7229C1.63855 12.4337 1.54217 12.0482 1.44578 11.2771C1.44578 10.4096 1.44578 10.2169 1.44578 8C1.44578 5.78313 1.44578 5.59036 1.44578 4.72289C1.44578 3.95181 1.63855 3.56627 1.73494 3.27711C1.92771 2.89157 2.0241 2.60241 2.31325 2.31325C2.60241 2.0241 2.89157 1.83133 3.27711 1.73494C3.56627 1.63855 3.95181 1.54217 4.72289 1.44578C5.59036 1.44578 5.87952 1.44578 8 1.44578ZM8 0C5.78313 0 5.59036 0 4.72289 0C3.85542 0 3.27711 0.192772 2.79518 0.385543C2.31325 0.578314 1.83133 0.867471 1.3494 1.3494C0.867471 1.83133 0.674699 2.21687 0.385543 2.79518C0.192772 3.27711 0.0963856 3.85542 0 4.72289C0 5.59036 0 5.87952 0 8C0 10.2169 0 10.4096 0 11.2771C0 12.1446 0.192772 12.7229 0.385543 13.2048C0.578314 13.6867 0.867471 14.1687 1.3494 14.6506C1.83133 15.1325 2.21687 15.3253 2.79518 15.6145C3.27711 15.8072 3.85542 15.9036 4.72289 16C5.59036 16 5.87952 16 8 16C10.1205 16 10.4096 16 11.2771 16C12.1446 16 12.7229 15.8072 13.2048 15.6145C13.6867 15.4217 14.1687 15.1325 14.6506 14.6506C15.1325 14.1687 15.3253 13.7831 15.6145 13.2048C15.8072 12.7229 15.9036 12.1446 16 11.2771C16 10.4096 16 10.1205 16 8C16 5.87952 16 5.59036 16 4.72289C16 3.85542 15.8072 3.27711 15.6145 2.79518C15.4217 2.31325 15.1325 1.83133 14.6506 1.3494C14.1687 0.867471 13.7831 0.674699 13.2048 0.385543C12.7229 0.192772 12.1446 0.0963856 11.2771 0C10.4096 0 10.2169 0 8 0Z"
                    fill="#DEDEDE"
                  />
                  <path
                    d="M8 3.85542C5.68675 3.85542 3.85542 5.68675 3.85542 8C3.85542 10.3133 5.68675 12.1446 8 12.1446C10.3133 12.1446 12.1446 10.3133 12.1446 8C12.1446 5.68675 10.3133 3.85542 8 3.85542ZM8 10.6988C6.55422 10.6988 5.30121 9.54217 5.30121 8C5.30121 6.55422 6.45783 5.30121 8 5.30121C9.44578 5.30121 10.6988 6.45783 10.6988 8C10.6988 9.44578 9.44578 10.6988 8 10.6988Z"
                    fill="#DEDEDE"
                  />
                  <path
                    d="M12.241 4.72289C12.7733 4.72289 13.2048 4.29136 13.2048 3.75904C13.2048 3.22671 12.7733 2.79518 12.241 2.79518C11.7086 2.79518 11.2771 3.22671 11.2771 3.75904C11.2771 4.29136 11.7086 4.72289 12.241 4.72289Z"
                    fill="#DEDEDE"
                  />
                </g>
              </svg>
              <span>Follow us on Instagram</span>
            </a>
          </div>
        </v-col>
        <v-col
          cols="6"
          style="height: 48px"
        >
          <div
            v-if="false"
            class="d-flex align-center ga-2"
          >
            <a
              href="https://wa.me/3477809129"
              target="_blank"
              rel="noopener noreferrer"
              class="d-flex ga-2 align-center footer-nav-hover text-decoration-none text-grey-darken-1"
            >
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.1 2.3C12.6 0.8 10.6 0 8.5 0C4.1 0 0.5 3.6 0.5 8C0.5 9.4 0.900006 10.8 1.60001 12L0.5 16L4.70001 14.9C5.90001 15.5 7.2 15.9 8.5 15.9C12.9 15.9 16.5 12.3 16.5 7.9C16.5 5.8 15.6 3.8 14.1 2.3ZM8.5 14.6C7.3 14.6 6.10001 14.3 5.10001 13.7L4.89999 13.6L2.39999 14.3L3.10001 11.9L2.89999 11.6C2.19999 10.5 1.89999 9.3 1.89999 8.1C1.89999 4.5 4.9 1.5 8.5 1.5C10.3 1.5 11.9 2.2 13.2 3.4C14.5 4.7 15.1 6.3 15.1 8.1C15.1 11.6 12.2 14.6 8.5 14.6ZM12.1 9.6C11.9 9.5 10.9 9 10.7 9C10.5 8.9 10.4 8.9 10.3 9.1C10.2 9.3 9.80001 9.7 9.70001 9.9C9.60001 10 9.49999 10 9.29999 10C9.09999 9.9 8.50001 9.7 7.70001 9C7.10001 8.5 6.70001 7.8 6.60001 7.6C6.50001 7.4 6.60001 7.3 6.70001 7.2C6.80001 7.1 6.9 7 7 6.9C7.1 6.8 7.10001 6.7 7.20001 6.6C7.30001 6.5 7.20001 6.4 7.20001 6.3C7.20001 6.2 6.80001 5.2 6.60001 4.8C6.50001 4.5 6.30001 4.5 6.20001 4.5C6.10001 4.5 5.99999 4.5 5.79999 4.5C5.69999 4.5 5.49999 4.5 5.29999 4.7C5.09999 4.9 4.60001 5.4 4.60001 6.4C4.60001 7.4 5.29999 8.3 5.39999 8.5C5.49999 8.6 6.79999 10.7 8.79999 11.5C10.5 12.2 10.8 12 11.2 12C11.6 12 12.4 11.5 12.5 11.1C12.7 10.6 12.7 10.2 12.6 10.2C12.5 9.7 12.3 9.7 12.1 9.6Z"
                  fill="#DEDEDE"
                />
              </svg>
              <span>Chat with us on WhatsApp</span>
            </a>
          </div>
        </v-col>
      </v-row>
      <div
        class="d-flex justify-space-between"
        style="font-size: 10px"
      >
        <div>© 2024 — Copyright</div>
        <svg
          @click="scrollToTop()"
          class="cursor-pointer"
          width="60"
          height="60"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            opacity="0.2"
            cx="30"
            cy="30"
            r="29.5"
            stroke="#DEDEDE"
          />
          <path
            d="M30 37L30 22M30 22L26 26M30 22L34 26"
            stroke="#DEDEDE"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useIsElementPresent } from '@/composables';
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  const scrollTo = (elementId: string) => {
    const el = document.getElementById(elementId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const { isPresent } = useIsElementPresent('faq');
  const hasFAQLink = isPresent;
</script>
<style scoped>
  .inner-rounded {
    position: relative;
    overflow: hidden;
    background-color: #212121;
    padding: 20px;
    color: white;
    border-radius: 20px 0 0 20px;
  }
  .inner-rounded::after {
    content: "";
    position: absolute;
    top: 50%;
    right: -39px;
    width: 49px;
    height: 160px;
    background-color: black;
    transform: translateY(-50%);
    border-radius: 50%;
    box-shadow: 0 0 0 10px #131619;
  }
  .footer-nav-hover{
    transition: all 0.2s ease-in-out;
  }

  .footer-nav-hover:hover{
    color: white !important;
  } 
  
  @media(max-width:768px){
    .inner-rounded::after {
        display: none;
      }
      
  }
  @media(min-width:960px){
    .nhp{
        max-width:55%;
      }
      
  }
</style>
